/**
 * Stato di avanzamento (28/10/2026): le task di un progetto (o di una persona) in
 * una barra sola, divisa in fatte, in corso, da fare e in ritardo.
 *
 * Parte del tutto: una barra orizzontale con i pezzi separati da 2px di vuoto, la
 * scala di grigi da fare, in corso, fatta (ordinata) e il rosso solo per il ritardo.
 * I numeri stanno anche scritti sotto, quindi il colore non è mai l'unico modo
 * di leggerli; il passaggio del mouse su un pezzo ne dice il nome.
 */
import { Icon } from '../ui/Icon';
import './charts.css';

export interface ConteggiAvanzamento {
  fatte: number;
  inCorso: number;
  daFare: number;
  inRitardo: number;
}

/** Conta le task per stato: in ritardo vince su da fare e in corso, così i pezzi non si sovrappongono. */
export function contaAvanzamento(task: Array<{ stato: string; inRitardo?: boolean }>): ConteggiAvanzamento {
  const c = { fatte: 0, inCorso: 0, daFare: 0, inRitardo: 0 };
  for (const t of task) {
    if (t.stato === 'DONE') c.fatte++;
    else if (t.inRitardo) c.inRitardo++;
    else if (t.stato === 'TODO') c.daFare++;
    else c.inCorso++;
  }
  return c;
}

export function Avanzamento({ c, etichetta }: { c: ConteggiAvanzamento; etichetta?: string }) {
  const tot = c.fatte + c.inCorso + c.daFare + c.inRitardo;
  if (tot === 0) return <p className="avz-frase">Nessuna task.</p>;
  const pezzi = [
    { k: 'fatta', n: c.fatte, nome: c.fatte === 1 ? 'fatta' : 'fatte' },
    { k: 'incorso', n: c.inCorso, nome: 'in corso' },
    { k: 'dafare', n: c.daFare, nome: 'da fare' },
    { k: 'ritardo', n: c.inRitardo, nome: 'in ritardo' },
  ].filter((p) => p.n > 0);
  const testo = `${c.fatte} di ${tot} ${tot === 1 ? 'fatta' : 'fatte'}`;
  return (
    <div className="avz" role="img" aria-label={`${etichetta ? `${etichetta}: ` : ''}${testo}${c.inRitardo ? `, ${c.inRitardo} in ritardo` : ''}`}>
      <span className="avz-barra" aria-hidden>
        {pezzi.map((p) => (
          <i key={p.k} className={`avz-${p.k}`} style={{ flexGrow: p.n }} title={`${p.n} ${p.nome}`} />
        ))}
      </span>
      <span className="avz-frase" aria-hidden>
        <b>{testo}</b>
        {c.inCorso > 0 && <> · {c.inCorso} in corso</>}
        {c.daFare > 0 && <> · {c.daFare} da fare</>}
        {c.inRitardo > 0 && <> · <span className="avz-rosso"><Icon name="alert" size={10} /> {c.inRitardo} in ritardo</span></>}
      </span>
    </div>
  );
}
